import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { PlacementRelationAdRequestDaily } from '../models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PlacementRelationAdRequestDailyService {

  private path = '/placement_relation_ad_request_dailies';

  constructor(private http: AlloxApiService) { }

  public search(id: number) {
    return this.http.get<[]>(this.path + '/' + id).pipe(
      map(objs => objs.map(obj => new PlacementRelationAdRequestDaily(obj)))
    );
  }
}
